import { render, staticRenderFns } from "./PowerButton.vue?vue&type=template&id=20397ed2&scoped=true&"
import script from "./PowerButton.vue?vue&type=script&lang=js&"
export * from "./PowerButton.vue?vue&type=script&lang=js&"
import style0 from "./PowerButton.scss?vue&type=style&index=0&id=20397ed2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20397ed2",
  null
  
)

export default component.exports